import React from "react";
import { MetaTags } from "react-meta-tags";
import {
  Card,
  CardBody,
  Col,
} from "reactstrap";
import UserTransactions from "./UserTransactions";
import { useSelector } from "react-redux";
import UserWallets from "./Wallets/UserWallets";

function MyWallets() {

  const { userData: usrData } = useSelector((state) => ({
    userData: state.Profile,
  }));


  return (
    <React.Fragment>
      <MetaTags>
        <title>
          My Wallets
        </title>
      </MetaTags>
      <div className="page-content">
        <div className="container-fluid">
          <UserWallets/>
          <Col className="col-12">
            <Card>
              <CardBody>
                <UserTransactions customerId={usrData?._id}/>
              </CardBody>
            </Card>
          </Col>
        </div>
      </div>
    </React.Fragment>
  );
}
export default MyWallets;
